// extracted by mini-css-extract-plugin
module.exports = {"message-container":"style_message-container__3CK1R","close-container":"style_close-container__2YDXC"};